import { EventFlowLocation } from '@/model/event-flow/EventFlow';

export type Location = {
    id: number | null;
    name: string | null;
    order: number | null;
    color?: string | null;
};

export type PutLocationRequest = {
    location: Location;
    eventId: number;
};

export type PostLocationRequest = PutLocationRequest;

export type DeleteLocationRequest = {
    eventId: number;
    locationId: number | null;
};

export function createEmptyLocation(): Location {
    return {
        id: 0,
        name: '',
        order: Infinity,
    };
}

export function createLocationFromEventFlowLocation(
    eventFlowLocation: EventFlowLocation,
): Location {
    return {
        id: eventFlowLocation.id,
        name: eventFlowLocation.name,
        order: eventFlowLocation.order,
    };
}
